export default "__VITE_ASSET__DJ6gx0RR__"